// ==============================|| OVERRIDES - TABS ||============================== //

export default function Tabs() {
  return {
    MuiTabs: {
      styleOverrides: {
        vertical: {
          overflow: 'visible'
        },
        indicator: {
          backgroundColor: 'var(--nv-brand)',
          height: 2
        }
      }
    }
  };
}
